<template>
  <div v-if="text" class="app-running-line">
    <p ref="lineRef" :class="['app-running-line__text', { 'static': !isRunning }]">{{ text }}</p>
  </div>
</template>

<script>
import { getRunningLineData } from '@/api/shop'

export default {
  name: 'runningLine',
  data() {
    return {
      text: '',
      isRunning: false,
    }
  },
  mounted() {
    getRunningLineData()
      .then((res) => {
        if (!res) {
          return
        }

        this.text = res.text
        this.isRunning = res.isRunning
        this.$nextTick(() => {
          this.setupAnimation()
        })
        this.$nextTick(() => {
          this.dispatchMountedEvent()
        })
      })

    this.handlePageMargin()
  },
  methods: {
    setupAnimation() {
      if (!this.$refs.lineRef) {
        return
      }

      if (!this.isRunning) {
        return
      }

      const lineWidth = this.$refs.lineRef.getBoundingClientRect().width
      const secondInMs = 1000
      const multiplier = 5
      const duration = ((lineWidth + window.innerWidth) / window.innerWidth) * (secondInMs * multiplier)

      this.$refs.lineRef.animate([
        { transform: 'translateX(100vw)' },
        { transform: `translateX(calc(-${lineWidth}px))` }
      ], {
        duration,
        iterations: Infinity,
      })
    },
    handlePageMargin() {
      const checkout = document.querySelector('[class="checkout"]')
      const mainContainer = document.querySelector('[class="container"]')

      if (checkout) {
        checkout.style.marginTop = '60px'
      }

      if (mainContainer) {
        mainContainer.style.marginTop = '50px'
      }
    },
    dispatchMountedEvent() {
      const event = new Event('RunningLineMounted')
      document.dispatchEvent(event)
    }
  },
}
</script>
